import { theme } from '@theme';
import styled from 'styled-components';

type LabelProps = {
  display?: string;
  color?: string;
  marginLeft?: number;
  fontWeight?: number;
};

type InputBoxWrapperProps = {
  isMobileDevice?: boolean;
  height?: string;
  paddingTopBottom?: string;
  paddingLeftRight?: string;
  isButton?: boolean;
  disabled?: boolean;
};

type TextAreaWrapperProps = {
  isMobileDevice?: boolean;
};

type IconProps = {
  type?: string;
  fontSize?: string;
  margin?: string;
  verticalAlign?: string;
  marginRight?: string;
};

type AttachFileWrapperProps = {
  fontSize?: string;
};
type AttachFileLabelProps = {
  fontSize?: string;
};
type SupportFormWrapperProps = {
  height?: string;
  padding?: string;
};

type DivWrapperProps = {
  marginLeft?: string;
};

export const Label = styled.span<LabelProps>`
  background-color: transparent;
  font-size: large;
  font-weight: ${(props) =>
    props.fontWeight ? props.fontWeight : theme.typography.fontWeights.normal};
  margin: 0px 0px 0px ${(props) => (props.marginLeft ? props.marginLeft : '0')}px;
  color: ${(props) => props.color ?? props.color};
  display: ${(props) => (props.display ? props.display : 'inline')};
  padding: 0px;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
`;

export const NameLabel = styled(Label)`
  word-break: break-all;
`;

export const EmailLabel = styled(Label)`
  word-wrap: break-word;
`;

export const CustomerDetailWrapper = styled.div`
  margin: 20px 0px 10px;
`;

export const InputBoxWrapper = styled.input<InputBoxWrapperProps>`
  min-width: ${(props) => (props.isButton ? '145px' : 'none')};
  font-weight: ${theme.typography.fontWeights.semibold};
  border: 1px solid ${theme.palette.lightGrey};
  font-size: ${(props) =>
    props.isButton ? `${theme.typography.fontSize16}` : `${theme.typography.fontSize}`}px;
  background-color: ${(props) =>
    props.isButton && props.disabled ? `${theme.palette.white}` : ''};
  width: ${(props) => (props.isButton && !props.isMobileDevice ? '30' : '100')}%;
  border-radius: ${(props) => (props.isButton ? '3' : '5')}px;
  margin: 5px 0;
  height: ${(props) => props.height ?? props.height}px;
  padding: ${(props) => props.paddingTopBottom ?? props.paddingTopBottom}px
    ${(props) => props.paddingLeftRight ?? props.paddingLeftRight}px;
  &:focus {
    outline: none;
    background-color: ${theme.palette.white};
    border-color: ${theme.palette.text.purple};
  }
  &:disabled {
    background-color: ${(props) =>
      props.isButton ? `${theme.palette.backgroundGray}` : `${theme.palette.lightGreyFive}`};
    border: ${(props) => (props.isButton ? 'none' : `1px solid ${theme.palette.backgroundGray}`)};
  }
  resize: vertical;
  max-height: 200px;
  ${(props) =>
    props.isMobileDevice
      ? ` box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25) inset;
            `
      : ''};
`;

export const TextAreaWrapper = styled.textarea<TextAreaWrapperProps>`
  border: 1px solid ${theme.palette.lightGrey};
  font-size: ${theme.typography.fontSize}px;
  background-color: ${theme.palette.white};
  width: 100%;
  border-radius: 5px;
  margin: 5px 0;
  &:focus {
    outline: none;
    background-color: ${theme.palette.white};
    border-color: ${theme.palette.text.purple};
  }
  &:disabled {
    background-color: ${theme.palette.lightGreyFive};
    border: 1px solid ${theme.palette.backgroundGray};
  }
  padding: 15px;
  resize: vertical;
  max-height: 200px;
  ${(props) =>
    props.isMobileDevice
      ? ` box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25) inset;
            max-height: none;
            height: 15vh;`
      : ''};
`;

export const SupportWrapper = styled.div``;
export const SupportFormWrapper = styled.form<SupportFormWrapperProps>`
  height: ${(props) => props.height};
  padding: 0 ${(props) => props.padding}px;
  .row {
    margin: 0 -5px;
  }
`;

export const DivWrapper = styled.div<DivWrapperProps>`
  padding: 0 5px;
  margin-left: ${(props) => props.marginLeft ?? props.marginLeft}px;
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  padding-top: 20px;
  padding-bottom: 40px;
`;

export const IconWrapper = styled.i.attrs<IconProps>((props) => ({
  className: `am-icon-${props.type}`,
}))<IconProps>`
  margin-left: ${(props) => props.margin}px;
  font-size: ${(props) => props.fontSize}%;
  vertical-align: ${(props) => props.verticalAlign};
  margin-right: ${(props) => props.marginRight ?? props.marginRight}px;
`;

export const AttachFileWrapper = styled.div<AttachFileWrapperProps>`
  position: relative;
  display: inline-block;
  color: ${theme.palette.blue};
  line-height: 13px;
  font-size: ${(props) => props.fontSize};
  padding: 5px 0;
  &:hover {
    color: ${theme.palette.sidebarGradient.from};
  }
  margin-right: 10px;
`;
export const AttachFileContainer = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  &:hover {
    cursor: pointer;
  }
`;

export const AttachFileLabel = styled.label<AttachFileLabelProps>`
  font-weight: ${theme.typography.fontWeights.semibold};
  font-size: ${(props) => props.fontSize};
  color: ${theme.palette.grey};
  word-break: break-all;
`;
